import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n';
import PublicLayout from '../components/PublicLayout';
import { LavashLogo, VeloraLogo } from '../components/brand/Logos';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function BrandsPage() {
  const { t } = useLanguage();
  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32" data-testid="brands-page">
        <p className="eyebrow mb-6">{t('ourBrands')}</p>
        <h1 className="h-display text-5xl md:text-7xl mb-16 max-w-3xl">
          {t('ourBrands')}
        </h1>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {/* LAVASH */}
          <Link
            to="/lavash"
            data-testid="brand-card-lavash"
            className="bg-[#F2EFE6] rounded-2xl p-10 md:p-14 hover:shadow-lg transition-all cff-hover-lift border border-transparent hover:border-[#556B2F]/30 group"
          >
            <LavashLogo size="lg" className="mb-10" />
            <p className="text-base md:text-lg text-[#556B2F]/85 leading-relaxed mb-8">
              {t('lavashCardDesc')}
            </p>
            <ul className="space-y-2 text-sm text-[#556B2F] mb-10">
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#556B2F]" /> {t('advNoYeast')}</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#556B2F]" /> {t('advNoPreservatives')}</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#556B2F]" /> {t('advClean')}</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#556B2F]" /> {t('advVersatile')}</li>
            </ul>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-[#556B2F] group-hover:gap-3 transition-all">
              LAVASH <ArrowRight className="h-4 w-4" />
            </span>
          </Link>

          {/* VELORA */}
          <Link
            to="/velora"
            data-testid="brand-card-velora"
            className="bg-[#F6E9E5] rounded-2xl p-10 md:p-14 hover:shadow-lg transition-all cff-hover-lift border border-transparent hover:border-[#8E2A4E]/30 group relative"
          >
            <span className="absolute top-6 right-6 inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase font-bold px-2.5 py-1 bg-[#8E2A4E] text-[#F6E9E5] rounded-sm">
              <Sparkles className="h-3 w-3" /> {t('veloraSoon')}
            </span>
            <VeloraLogo size="lg" className="mb-10" />
            <p className="text-base md:text-lg text-[#6E4D3A]/85 leading-relaxed mb-8">
              {t('veloraCardDesc')}
            </p>
            <ul className="space-y-2 text-sm text-[#6E4D3A] mb-10">
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#8E2A4E]" /> {t('advLessSugar')}</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#8E2A4E]" /> {t('advNoPreservatives')}</li>
              <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#8E2A4E]" /> {t('advClean')}</li>
            </ul>
            <span className="inline-flex items-center gap-2 text-sm font-bold text-[#8E2A4E] group-hover:gap-3 transition-all italic font-playfair">
              VELORA <ArrowRight className="h-4 w-4" />
            </span>
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
